import { Footer } from "@/components/Footer";
import { Header } from "@/components/Header";
import { Konduto } from "@/components/Konduto";
import { CookiesModal } from "@/components/Modal/CookiesModal";
import { AuthProvider, CartProvider, FeatureProvider } from "@/contexts";
import { LoadingProvider } from "@/contexts/LoadingContext";
import "@/styles/global/carousel.scss";
import "@/styles/global/global.scss";
import { textStyleLingLong } from "@/styles/theme";
import { EnableCSRF } from "@/utils/useCsrf";
import { DisableDebug } from "@/utils/useDebug";
import { ChakraProvider, Fade } from "@chakra-ui/react";
import { DefaultSeo } from "next-seo";
import { AppProps } from "next/app";
import { useRouter } from "next/router";
import { SEO } from "../../next-seo.config";
import { ZapButton } from "@/utils/whatsAppButton";
import { DisableWarn } from "@/utils/disableWarnings";
import { MadeBy } from "@/utils/madeBy";
function App({ Component, pageProps }: AppProps | any) {
  const router = useRouter();

  MadeBy();
  DisableDebug();
  EnableCSRF();
  DisableWarn();

  return (
    <LoadingProvider>
      <FeatureProvider>
        <AuthProvider>
          <Konduto />
          <CartProvider>
            <ChakraProvider theme={textStyleLingLong} resetCSS>
              <DefaultSeo
                title="Loja Oficial LingLong | Compre Pneus Online e Receba Super Rápido.
Promoções de pneus LingLong ✓ Menor Custo de Frete ✓ Compra Segura em até 12x."
                {...SEO}
              />
              {/* <ZapButton /> */}
              <Header />
              <Fade
                key={router.route}
                in={true}
                style={{
                  minHeight: "calc(100vh - 270px)"
                }}
              >
                <Component {...pageProps} />
              </Fade>
              <Footer />
              {/* <CookiesModal /> */}
            </ChakraProvider>
          </CartProvider>
        </AuthProvider>
      </FeatureProvider>
    </LoadingProvider>
  );
}

export default App;
